import styled, { css, keyframes } from 'styled-components'

import A from '../A'
import Icon from '../Icon'

const fadeIn = keyframes`
  0% { 
   opacity: 0;
  }

  100% {
    opacity: 1;
  }
`

export const NavMegaMenuContainer = styled.nav<{ isOpen?: boolean; ref?: any }>`
  padding-top: 10rem;
  overflow: hidden;
  border-radius: 0 0 6rem 6rem;
  background-color: ${({ theme }) => theme.colors.pureWhite ?? 'white'};
  z-index: ${({ theme }) => theme.zIndexes.header - 1};
`
export const NavMegaMenuWrapper = styled.div`
  position: relative;
  display: flex;
  flex-flow: row nowrap;
  margin-left: auto;
  margin-right: auto;
  max-height: 30rem;
  & > * {
    position: relative;
    flex: 0 0 auto;
  }
  &::before {
    content: '';
    position: absolute;
    top: -2px;
    left: 50%;
    z-index: ${({ theme }) => theme.zIndexes.minimalContent};
    width: 100vw;
    height: 2px;
    background-color: ${({ theme }) => theme.colors.greyDD ?? 'lightgrey'};
    transform: translateX(-50%);
  }
`
//
export const PanelPush = styled.div`
  width: 33%;
  padding-top: 0;
`
//
export const PanelTwo = styled.div`
  width: 31%;
  padding: 2rem 3rem 4rem 4rem;
`
export const LinksTwo = styled.ul`
  list-style: none;
`
export const LinksTwoItem = styled.li`
  ${({ theme }) => theme.textStyles.text_medium_18}
  &:not(:first-child) {
    margin-top: 2rem;
  }
`
type MenuLink = {
  isActive?: boolean
  isCurrent?: boolean
  isHovered?: boolean
}
export const LinksTwoLink = styled(A)<MenuLink>`
  ${({ theme }) => theme.textStyles.text_medium_16}
  font-weight: 500;
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 1.6rem;
  overflow: hidden visible;
  color: ${({ theme, isCurrent }) =>
    isCurrent ? theme.colors.greenApple : theme.colors.pureBlack};
  text-decoration: none;
  & > * {
    flex: 0 0 auto;
  }
  & > span:first-child {
    flex: 0 1 auto;
    padding-top: 0.4rem;
    padding-bottom: 0.4rem;
  }
  // hover
  ${({ theme, isHovered }) =>
    isHovered &&
    css`
      &,
      &:hover {
        color: ${theme.colors.greenEmerald ?? 'black'};
      }
      & > span:first-child {
        text-decoration: underline;
        text-decoration-line: underline;
        text-decoration-style: solid;
        text-decoration-color: ${theme.colors.greenEmerald ?? 'lightgreen'};
        text-decoration-thickness: 0.5rem;
        text-underline-position: under;
      }
    `}
`
export const LinksTwoIcon = styled(Icon)`
  width: 1rem;
  height: 2rem;
  transform: scale(1);
  margin-left: 2rem;
  a:hover > &,
  a:focus > & {
    color: ${({ theme }) => theme.colors.greenEmerald ?? 'lightgreen'};
  }
  & svg {
    display: block;
    min-width: 100%;
    max-width: 100%;
    min-height: 100%;
    max-height: 100%;
  }
`
//
export const PanelThree = styled.div<{ hasItems?: boolean }>`
  width: 36%;
  padding: 2rem 3rem 3rem;
  & > * {
    position: relative;
  }
  &::before {
    opacity: ${({ hasItems }) => (hasItems ? css`1` : css`0`)};
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    width: 100vw;
    background-color: ${({ theme }) => theme.colors.greyf5 ?? 'lightgrey'};
    box-shadow: inset 5px 0px 12px rgba(0, 0, 0, 0.1);
    transition: opacity 500ms linear;
  }
`
export const LinksThree = styled.ul`
  list-style: none outside;
  animation-name: ${fadeIn};
  animation-duration: 0.4s;
  animation-fill-mode: forwards;
  animation-timing-function: cubic-bezier(0.455, 0.03, 0.515, 0.955);
`
export const LinksThreeItem = styled.li`
  ${({ theme }) => theme.textStyles.text_medium_16}
  &:not(:first-child) {
    margin-top: 2rem;
  }
`
export const LinksThreeLink = styled(A)`
  ${({ theme }) => theme.textStyles.text_medium_16}
  text-decoration: none;
  overflow: hidden visible;
  &,
  &:hover {
    color: ${({ theme }) => theme.colors.pureBlack};
  }
  & > span {
    flex: 0 1 auto;
    overflow: hidden visible;
    line-height: 1.5;
  }
  &:hover > span {
    text-decoration: underline;
    text-decoration-line: underline;
    text-decoration-style: solid;
    text-decoration-color: ${({ theme }) =>
      theme.colors.greenEmerald ?? 'lightgreen'};
    text-decoration-thickness: 0.2rem;
    text-underline-position: under;
  }
`
